/**
 * wrapperAlign 包含 unknown 是因为存在 PC 一码多端传递过来的未知类型
 */
export var useWrapperAlign = function (wrapperAlign) {
    if (wrapperAlign === 'right') {
        return 'right';
    }
    return 'left';
};
